<template>
    <div class="chat-region" id="chat">
        <div class="users-region">
            <a href="#" :class="[room.lead_id === chat_id ? 'user-link active' : 'user-link']" @click="useChat(room.lead_id,room.lead_id)" v-for="room in rooms" :key="room.id">
                <div class="user-region">
                    <span class="name">#{{room.lead_id}} {{room.name}} <div v-if="room.unread > 0" class="amount -active">{{room.unread}}</div></span>
                </div>
            </a>
        </div>
        <div class="main-region">
            <div class="chat-header">
                <img class="avatar" style="display: none" src="/static/img/autopilote-logo.png">
                <div class="user-name">
                    <span class="name">#{{active.lead_id}} {{active.name}}</span>
                </div>
                <a href="#" @click="hideChat" class="menu-region fa fa-close" ></a>
            </div>
            <div id="chat_messages" class="chat-content">
                <div class="messages" v-for="(message, index) in messages" :key="index">
                    <div class="user-message" v-if="message.client_id === auth.id">
                        <div class="this-message">
                            <div class="thismessage">
                                <span class="message">{{message.message}}</span>
                            </div>
                            <div class="state-status">
                                <span class="state" v-if="message.seen">Прочитано</span>
                                <span class="state" v-else>Отправлено</span>
                            </div>
                        </div>
                        <span class="time">{{message.date}}</span>
                    </div>
                    <div class="opponent-message" v-else>
                        <div class="this-message">
                            <div class="thismessage">
                                <span class="message">{{message.message}}</span>
                            </div>
                            <div class="state-status">
                                <span class="state" v-if="message.seen">Прочитано</span>
                                <span class="state" v-else>Отправлено</span>
                            </div>
                        </div>
                        <span class="time">{{message.date}}</span>
                    </div>
                </div>
            </div>
            <div class="chat-footer">
                <textarea class="textarea" v-on:keyup.enter="sendMessage" type="text" name="answer" v-model="mess" placeholder="Введите сообщение"></textarea>
                <div class="chat-buttons">
                    <label class="send" @click="sendMessage">
                        <button class="icon"></button>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'chat',
  props: ['city', 'user', 'auth', 'leads', 'chat_id', 'lead_id'],
  data () {
    return {
      lead: this.lead_id,
      chat: this.chat_id,
      rooms: [],
      messages: [],
      active: {},
      mess: null
    }
  },
  methods: {
    sendMessage () {
      var mes = this.mess.replace(new RegExp('\\n', 'g'), '')
      if (mes && mes !== '' && mes !== ' ' && mes !== null && mes !== '\n') {
        this.messages.push({
          'id': 0,
          'service_id': 0,
          'client_id': this.auth.id,
          'message': this.mess,
          'date': '',
          'seen': 0
        })
        var formData = new FormData()
        formData.append('message', this.mess)
        axios.post('https://crm.v-avtoservice.com/list/client-chat?uid=' + this.user.uid + '&client_id=' + this.auth.id + '&lead_id=' + this.chat,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        this.mess = null
      } else {
        this.mess = null
      }
    },
    hideChat () {
      this.$parent.chat_id = 0
    },
    useChat (id, ids) {
      this.$parent.chat_id = id
      this.$parent.lead_id = ids
      this.chat = id
      this.lead = ids
      this.messages = []
      this.active = {}
      this.initChat()
    },
    initChat () {
      axios.get('https://crm.v-avtoservice.com/list/site-client-chat?uid=' + this.user.uid + '&client_id=' + this.auth.id + '&lead_id=' + this.chat).then(response => {
        this.rooms = response.data.rooms
        this.messages = response.data.messages
        this.active = response.data.active
      })
    }
  },
  watch: {
    messages: function (v) {
      setTimeout(function () {
        var container = document.querySelector('#chat_messages')
        container.scrollTop = container.scrollHeight
      }, 100)
    }
  },
  created () {
    this.interval = setInterval(() => {
      this.initChat()
    }, 30 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  mounted () {
    this.initChat()
  }
}
</script>

<style scoped>
    #chat {
        left: 0;
        right: 0;
        z-index: 1;
    }
    #chat .amount.-active{
        display: flex;
        top: calc(50% - 10px);
        right: 10px;
    }
    #chat:before {
        background: #000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: fixed;
        content: '';
        opacity: 0.9;
        z-index: 1;
    }
    .users-region, .main-region {
        z-index: 2;
    }
    .menu-region.fa.fa-close {
        font-size: 30px;
        font-weight: 100;
        text-decoration: none!important;
    }
    .user-link.active .user-region {
        background: #0054c1;
    }
</style>



// WEBPACK FOOTER //
// src/components/cabinet/user/chat.vue